import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { LoginService } from '../login/login.service';
import { AuthenticationService } from '@app/auth';
import { BehaviorSubject, Observable, of } from 'rxjs';

const PAYMENTGATEWAYHOST = environment.paymentGatewayhost;
@Injectable({
  providedIn: 'root',
})
export class PaymentPlansService {
  private nextBtnDisabled = new BehaviorSubject<boolean>(true);
  currentValue = this.nextBtnDisabled.asObservable();

  get isNextBtnDisabled(): boolean {
    return this.nextBtnDisabled.value;
  }

  constructor(
    private httpClient: HttpClient,
    private loginService: LoginService,
    public authService: AuthenticationService,
  ) { }

  disableNextBtn(value: boolean) {
    this.nextBtnDisabled.next(value);
  }

  /* Verify referral email */
  public checkReferralEmail(emailId: string) {
    /* const token = sessionStorage.getItem('token');
     let headers = new HttpHeaders()
     .set('Content-Type', 'application/json; charset=utf-8')
     .set('Authorization', 'Bearer ' + token);*/
    //return this.httpClient.get(`/agent/`+ emailId, { headers })
    return this.httpClient.get(`/agent/` + emailId);
  }

  getPaymentMethods() {
    /*const token = sessionStorage.getItem('token');
        let headers = new HttpHeaders()
        .set('Content-Type', 'application/json; charset=utf-8')
        .set('Authorization', 'Bearer ' + token);*/
    // return this.httpClient.get('/paymentType', {headers});
    return this.httpClient.get('/paymentType');
  }

  getPaymentPlans() {
    return this.httpClient.get('/paymentplan');
  }

  updateRamJSON(body: any, action: any) {
    const vformDataUP = new FormData();
    vformDataUP.append('model', JSON.stringify(body));
    return this.httpClient.put(`/orders?action=${action}`, vformDataUP);
  }


  getAcornToken() {
    /*const token = sessionStorage.getItem('token');
    let headers = new HttpHeaders()
    .set('Content-Type', 'application/json; charset=utf-8')
    .set('Authorization', 'Bearer ' + token);*/
    // return this.httpClient.get('/acorntoken', {headers});
    const token = sessionStorage.getItem("token") ?? "";
    try {
      let decodedToken: any = this.loginService.decodeToken(token);
      if (decodedToken && decodedToken.hasOwnProperty("acornToken") && decodedToken.acornToken) {
        const acornToken = decodedToken.acornToken;
        return of({ token: acornToken });
      } else {
        return this.httpClient.get('/acorntoken');
      }
    } catch (err) {
      console.log("error decoding token", err);
      return this.httpClient.get('/acorntoken');
    }

  }

  createPaymentGatewayCustomer(customerInfo: any, acornToken: any) {
    return this.httpClient.post(PAYMENTGATEWAYHOST + '/customers/' + acornToken, customerInfo);
  }

  getCustomerPaymentMethodInfo(
    paymentProcessorCustomerId: any,
    accountID: any,
    paymentProcessor: any,
    acornToken: any,
  ) {
    return this.httpClient.get(
      PAYMENTGATEWAYHOST +
      '/customers/' +
      paymentProcessorCustomerId +
      '/accounts/' +
      accountID +
      '/' +
      acornToken +
      '?paymentProcessor=' +
      paymentProcessor,
    );
  }

  getPaymentProcessorCheckOutToken(paymentProcessorCustomerID: any, paymentProcessor: string, acornToken: any) {
    return this.httpClient.get(
      PAYMENTGATEWAYHOST +
      '/customers/' +
      paymentProcessorCustomerID +
      '/checkouttoken/' +
      acornToken +
      '?paymentProcessor=' +
      paymentProcessor,
    );
  }

  fetchCurrencies(code: any) {
    /* const token = sessionStorage.getItem('token');
     let headers = new HttpHeaders()
       .set('Content-Type', 'application/json; charset=utf-8')
       .set('Authorization', 'Bearer ' + token);*/
    //return this.httpClient.get('/currency/' + code, {headers});
    return this.httpClient.get('/currency/' + code);
  }

  zohoHomeAddress(zohoEncryptedId: any) {
    return this.httpClient.post<any>('/zoho/homeAddress', {
      zohoEncryptedId: zohoEncryptedId,
    });
  }

  getAgentByEmail(email: string): Observable<Agent> {
    return this.httpClient.get<Agent>('/agent', { params: { emailId: email } });
  }

  getCustomerPaymentInstruments(customerId: number): Observable<CustomerPaymentInstrument[]> {
    return this.httpClient.get<CustomerPaymentInstrument[]>(`/customer-payment-instruments?billing_customer_id=${customerId}`);
  }
}

export interface Agent {
  agentId: number;
  email: string;
  firstName: string;
  lastName: string;
  type: string;
  company: string;
  phone: string;
}

export interface CustomerPaymentInstrument {
  customerPaymentInstrumentId: number;
  billingCustomerId: number;
  paymentMethodTypeId: number;
  ccNumber: string;
  paymentProcessorRef: string;
  status: string;
  createdDate: string | null;
  createdBy: string;
  updatedDate: string | null;
  updatedBy: string | null;
  ccExpirationDate: string;
  ccIssuer: string;
  achAccountNumber: string | null;
  achBankName: string | null;
  achRoutingNumber: string | null;
  achAccountType: string | null;
  nameOnAccount: string;
  bracct: string | null;
  contactEmail: string | null;
  chkNumber: string | null;
  chkAccountNumber: string | null;
  chkRoutingNumber: string | null;
  chkBankName: string | null;
  chkImageRef: string | null;
  applied: string;
  receiptsBankAccountNumber: string | null;
  usage: string;
  replacementPaymentProcessorRef: string | null;
  referenceFileName: string | null;
  referenceFileType: string | null;
  achInstitutionNumber: string | null;
  processorSetupIntent: string | null;
  paymentMethodCode: string;
  paymentType: string;
  transactionTypeId: number;
  availableForMonthly: boolean;
  availableForAddFlow: boolean;
  depositBankName: string | null;
}
